import { defineComponent as _defineComponent } from 'vue'
import { PaginatedRest } from '@/types/Rest';
import { DataOptions } from 'vuetify';
import { useVModel } from '@vueuse/core';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsDataTable',
  props: {
    value: null
  },
  emits: ['page:change'],
  setup(__props: any, { emit }) {

const props = __props as { value: PaginatedRest<unknown> };





const data = useVModel(props, undefined, emit);

const options = computed(() => ({
  page: data.value.number + 1,
  itemsPerPage: data.value.size,
  totalElements: data.value.totalElements,
}));

const setPageable = (pageable: DataOptions) => {
  const { page, itemsPerPage } = pageable;

  data.value.number = page - 1;
  data.value.size = itemsPerPage;

  emit('page:change');
};

return { __sfc: true,emit, props, data, options, setPageable }
}

})